// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import Image from '/react4xp/components/Image'
import Button from '/react4xp/components/Button'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

// prop types
interface EntryCardProps {
    imagePosition?: 'left' | 'right'
    src?: string
    srcMobile?: string
    alt?: string
    title?: string
    text?: string
    hrefText?: string
    href?: string
    external?: boolean
    className?: string
}

export default function EntryCard({
    imagePosition,
    src,
    srcMobile,
    alt,
    title,
    text,
    hrefText,
    href,
    external,
    className
}: EntryCardProps) {
    return (
        <Section className='entry-card'>
            <div className={clsx(
                'container relative',
                isNonWhitespaceString(src) ? '' : 'no-image'
            )}>

                <div className={clsx(
                    'entry-card__box',
                    imagePosition === 'left' && 'entry-card__box--left',
                    imagePosition === 'right' && 'entry-card__box--right',
                    className
                )}>

                    <div className={clsx(
                        'entry-card__image-wrapper',
                        isNonWhitespaceString(src) ? '' : 'entry-card__image-wrapper--no-image'
                    )}>
                        {isNonWhitespaceString(src) && (
                            <div className='entry-card__image'>
                                <Image
                                    src={src} // 700px x 600px
                                    srcMedium={srcMobile} // 500px x 350px
                                    alt={alt}
                                    width={700}
                                    sizes='(max-width: 768px) 100vw, 600px'
                                    className='cover'
                                />
                            </div>
                        )}
                    </div>

                    <div className='entry-card__wrapper black'>

                        {isNonWhitespaceString(title) && (
                            <h2 className='h1-hero-small'>
                                {title}
                            </h2>
                        )}

                        {isNonWhitespaceString(text) && (
                            <div
                                className='entry-card__wrapper__text'
                                dangerouslySetInnerHTML={{ __html: text }}
                                suppressHydrationWarning
                            />
                        )}

                        {isNonWhitespaceString(hrefText) && (
                            <Button
                                href={href}
                                target={!!external}
                                noUnderline
                            >
                                {hrefText}
                            </Button>
                        )}

                    </div>

                </div>
            </div>
        </Section>
    )
}